module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    staticClass: "modern-ui",
    attrs: {
      "name": "messagePreview"
    },
    on: {
      "page:afteranimation": _vm.initPage
    }
  }, [_c('bc-navbar', {
    attrs: {
      "showLogo": true,
      "logoSrc": _vm.rafLogo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('referral-program-banner', {
    attrs: {
      "referralProgramId": _vm.referralProgramType
    }
  }), _vm._v(" "), (_vm.currentStep === _vm.AddReferralStep.NumberEntered) ? [_c('section', {
    staticClass: "page-title"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("\n          Here’s your message to " + _vm._s(_vm.name) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Send a personal note that opens " + _vm._s(_vm.name) + " intro page - not just a link.")])]), _vm._v(" "), _c('div', {
    staticClass: "info-card",
    attrs: {
      "type": "info"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21.5 16.0503V7.94625C21.4993 7.39798 21.3896 6.85532 21.1774 6.34976C20.9652 5.84421 20.6548 5.38584 20.264 5.00125C19.4679 4.21824 18.3956 3.77999 17.279 3.78125H6.72C5.60337 3.77999 4.53109 4.21824 3.735 5.00125C3.34442 5.38592 3.03412 5.84433 2.82211 6.34988C2.61011 6.85543 2.50062 7.39805 2.5 7.94625V16.0503C2.5 17.1553 2.945 18.2143 3.736 18.9953C4.53209 19.7783 5.60437 20.2165 6.721 20.2153H17.28C18.4 20.2153 19.473 19.7753 20.265 18.9953C20.6558 18.6107 20.9662 18.1523 21.1784 17.6467C21.3906 17.1412 21.4993 16.5985 21.5 16.0503Z",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.6308 15.9673C11.6308 15.1553 11.3067 14.3773 10.7287 13.8023C10.1498 13.2264 9.36635 12.9032 8.54975 12.9032C7.73315 12.9032 6.94975 13.2264 6.37075 13.8023C6.08497 14.0857 5.85814 14.423 5.70333 14.7946C5.54852 15.1662 5.46879 15.5647 5.46875 15.9673M14.5658 8.91825H18.1597M14.5658 11.9993H16.1057M14.5658 15.0803H18.1597M8.54975 12.1393C9.0945 12.1393 9.61695 11.9228 10.0021 11.5376C10.3873 11.1524 10.6037 10.63 10.6037 10.0853C10.6037 9.5405 10.3873 9.01805 10.0021 8.63285C9.61695 8.24765 9.0945 8.03125 8.54975 8.03125C8.005 8.03125 7.48255 8.24765 7.09735 8.63285C6.71215 9.01805 6.49575 9.5405 6.49575 10.0853C6.49575 10.63 6.71215 11.1524 7.09735 11.5376C7.48255 11.9228 8.005 12.1393 8.54975 12.1393Z",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Your friend's intro page")]), _vm._v(" "), _c('p', {
    ref: ""
  }, [_vm._v("This text opens " + _vm._s(_vm.name) + "'s personal intro page, where a friend will see your review, meet " + _vm._s(_vm.salesPersonName) + ", and\n          have easy ways to start shopping.")])]), _vm._v(" "), _c('div', {
    staticClass: "card elevated message-preview"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Your message preview")]), _vm._v(" "), _c('div', {
    staticClass: "card preview-text"
  }, [_c('p', {
    ref: "messageText"
  }, [_vm._v("Hey " + _vm._s(_vm.name) + ", I worked with " + _vm._s(_vm.salesPersonName) + " at " + _vm._s(_vm.dealerName) + " and had a great experience. I made this quick\n            intro page for you in case you're thinking about a vehicle: "), _c('a', {
    staticClass: "preview-link",
    attrs: {
      "href": _vm.referralLink,
      "target": "_blank",
      "rel": "external"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v(_vm._s(_vm.referralLink))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info-card"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 9H16M8 13H14M18 4C18.7956 4 19.5587 4.31607 20.1213 4.87868C20.6839 5.44129 21 6.20435 21 7V15C21 15.7956 20.6839 16.5587 20.1213 17.1213C19.5587 17.6839 18.7956 18 18 18H13L8 21V18H6C5.20435 18 4.44129 17.6839 3.87868 17.1213C3.31607 16.5587 3 15.7956 3 15V7C3 6.20435 3.31607 5.44129 3.87868 4.87868C4.44129 4.31607 5.20435 4 6 4H18Z",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("We added " + _vm._s(_vm.phone) + " as " + _vm._s(_vm.name) + "'s number. Tapping the button below will open your text app with this\n          message ready to send.")])]), _vm._v(" "), _c('button', {
    staticClass: "mui-button ripple accent",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openMessage()
      }
    }
  }, [_c('send-icon'), _vm._v("\n        Text " + _vm._s(_vm.name) + "\n      ")], 1)] : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.AddReferralStep.NoNumberEntered) ? [_c('section', {
    staticClass: "page-title"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("\n          Here’s your message to " + _vm._s(_vm.name) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("We created a message and personalized link for you. We'll copy your message, then open\n          your share menu so you can choose who to send it to.")])]), _vm._v(" "), _c('div', {
    staticClass: "info-card tip-card",
    attrs: {
      "type": "info"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 10.9837C11 10.7185 11.1054 10.4641 11.2929 10.2766C11.4804 10.089 11.7348 9.98369 12 9.98369C12.2652 9.98369 12.5196 10.089 12.7071 10.2766C12.8946 10.4641 13 10.7185 13 10.9837V16.9837C13 17.2489 12.8946 17.5033 12.7071 17.6908C12.5196 17.8783 12.2652 17.9837 12 17.9837C11.7348 17.9837 11.4804 17.8783 11.2929 17.6908C11.1054 17.5033 11 17.2489 11 16.9837V10.9837ZM12 6.05469C11.7348 6.05469 11.4804 6.16004 11.2929 6.34758C11.1054 6.53512 11 6.78947 11 7.05469C11 7.3199 11.1054 7.57426 11.2929 7.76179C11.4804 7.94933 11.7348 8.05469 12 8.05469C12.2652 8.05469 12.5196 7.94933 12.7071 7.76179C12.8946 7.57426 13 7.3199 13 7.05469C13 6.78947 12.8946 6.53512 12.7071 6.34758C12.5196 6.16004 12.2652 6.05469 12 6.05469Z",
      "fill": "#033BAA"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12Z",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("TIP from us")]), _vm._v(" "), _c('p', [_vm._v("Add " + _vm._s(_vm.name) + "'s phone number on the previous screen if you want us to open a ready-to-send text automatically.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "card elevated message-preview"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Your message preview")]), _vm._v(" "), _c('div', {
    staticClass: "card preview-text"
  }, [_c('p', {
    ref: "copyText"
  }, [_vm._v("Hey " + _vm._s(_vm.name) + ". If you're still shopping, I worked with " + _vm._s(_vm.salesPersonName) + " and it was a great experience. No pressure at all — here's the link if you want it: "), _c('a', {
    staticClass: "preview-link",
    attrs: {
      "href": _vm.referralLink,
      "target": "_blank",
      "rel": "external"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v(_vm._s(_vm.referralLink))])])])]), _vm._v(" "), _c('button', {
    staticClass: "mui-button ripple accent",
    on: {
      "click": function($event) {
        return _vm.copyAndShare()
      }
    }
  }, [_c('send-icon'), _vm._v("\n        Copy message & open share menu\n      ")], 1), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("We'll copy the message first — then you can pick your friend and paste it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n        Want the faster option? "), _c('br'), _vm._v("\n        Go back and add " + _vm._s(_vm.name) + "'s phone number.")])] : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('loader', {
    attrs: {
      "show": _vm.loading
    }
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1322cef6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1322cef6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/referral-program/message-preview.vue
// module id = 786
// module chunks = 0